// extracted by mini-css-extract-plugin
export default {"tickbox":"chat_menu___tickbox___ca85479a"};